module.exports = __webpack_public_path__ + "img/Recycle_pre.62ce1adc.png";